import React from "react";
import "./RejectDialog.css";

const RejectDialog = ({
  open,
  reason,
  setReason,
  onReject,
  onCancel,
  title = "Are you sure you want to Reject?",
}) => {
  if (!open) return null;

  return (
    <div className="reject-modal-overlay">
      <div className="reject-modal-content">
        <h2 className="reject-modal-title">{title}</h2>
        <div className="reject-modal-icon">
          <span>?</span>
        </div>
        <div className="reject-modal-label">Give Reason</div>
        <textarea
          className="reject-modal-textarea"
          placeholder="Write Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          required
        />
        <div className="reject-modal-actions">
          <button
            className="reject-modal-btn reject"
            onClick={onReject}
            disabled={!reason.trim()}
          >
            Reject
          </button>
          <button className="reject-modal-btn cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectDialog;